var _rect, _circle, _circle2, _g, _rect2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusiveWorkshops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 185,
    viewBox: "0 0 263 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2590_4897)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "#111213"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 132,
    cy: 93,
    r: 74.7991,
    stroke: "url(#paint0_linear_2590_4897)",
    strokeOpacity: 0.72,
    strokeWidth: 0.401822
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 132,
    cy: 93,
    r: 119.799,
    stroke: "url(#paint1_linear_2590_4897)",
    strokeOpacity: 0.48,
    strokeWidth: 0.401822
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_2590_4897)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 93,
    r: 46,
    fill: "url(#paint2_linear_2590_4897)",
    fillOpacity: 0.24,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 93,
    r: 45.7991,
    stroke: "url(#paint3_linear_2590_4897)",
    strokeOpacity: 0.64,
    strokeWidth: 0.401822,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2590_4897",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 63,
    width: 64,
    height: 64
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 63,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2590_4897)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 116.026C131.015 116.026 130.168 115.74 129.457 115.167C128.745 114.594 128.328 113.858 128.205 112.959H126.667C125.952 112.959 125.329 112.693 124.797 112.161C124.266 111.63 124 111.007 124 110.292V102.261C121.241 100.733 119.107 98.6496 117.597 96.01C116.088 93.3709 115.333 90.5898 115.333 87.6667C115.333 83.0067 116.946 79.064 120.172 75.8387C123.397 72.6129 127.34 71 132 71C136.66 71 140.603 72.6129 143.828 75.8387C147.054 79.064 148.667 83.0067 148.667 87.6667C148.667 90.6102 147.912 93.3964 146.403 96.0253C144.893 98.6547 142.759 100.733 140 102.261V110.292C140 111.007 139.734 111.63 139.203 112.161C138.671 112.693 138.048 112.959 137.333 112.959H135.795C135.671 113.858 135.254 114.594 134.543 115.167C133.832 115.74 132.984 116.026 132 116.026ZM126.667 110.292H137.333V107.687H126.667V110.292ZM126.667 105.636H137.333V103H126.667V105.636ZM126.133 100.333H130.821V92.0053L125.261 86.446L126.933 84.7747L132 89.8413L137.067 84.7747L138.739 86.446L133.179 92.0053V100.333H137.867C140.267 99.1778 142.222 97.4778 143.733 95.2333C145.244 92.9889 146 90.4667 146 87.6667C146 83.7556 144.644 80.4444 141.933 77.7333C139.222 75.0222 135.911 73.6667 132 73.6667C128.089 73.6667 124.778 75.0222 122.067 77.7333C119.355 80.4444 118 83.7556 118 87.6667C118 90.4667 118.755 92.9889 120.267 95.2333C121.778 97.4778 123.733 99.1778 126.133 100.333Z",
    fill: "url(#paint4_linear_2590_4897)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_2590_4897)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2590_4897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.8174,
    y: 17,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4426 31.9375L83.1926 30.1875L81.4426 28.4375L79.6926 30.1875L81.4426 31.9375ZM78.8176 36.75C78.3364 36.75 77.9244 36.5786 77.5817 36.2359C77.239 35.8932 77.0676 35.4812 77.0676 35V27.125C77.0676 26.6437 77.239 26.2318 77.5817 25.8891C77.9244 25.5464 78.3364 25.375 78.8176 25.375H92.8176C93.2989 25.375 93.7109 25.5464 94.0536 25.8891C94.3963 26.2318 94.5676 26.6437 94.5676 27.125V35C94.5676 35.4812 94.3963 35.8932 94.0536 36.2359C93.7109 36.5786 93.2989 36.75 92.8176 36.75H89.9958C90.0833 36.4583 90.1416 36.1667 90.1708 35.875C90.1999 35.5833 90.1999 35.2917 90.1708 35H92.8176V27.125H78.8176V35H81.4645C81.4353 35.2917 81.4353 35.5833 81.4645 35.875C81.4937 36.1667 81.552 36.4583 81.6395 36.75H78.8176ZM89.7551 30.625C90.1197 30.625 90.4296 30.4974 90.6848 30.2422C90.94 29.987 91.0676 29.6771 91.0676 29.3125C91.0676 28.9479 90.94 28.638 90.6848 28.3828C90.4296 28.1276 90.1197 28 89.7551 28C89.3905 28 89.0806 28.1276 88.8254 28.3828C88.5702 28.638 88.4426 28.9479 88.4426 29.3125C88.4426 29.6771 88.5702 29.987 88.8254 30.2422C89.0806 30.4974 89.3905 30.625 89.7551 30.625ZM79.6926 44.625V42.7875C79.6926 42.2771 79.8348 41.8031 80.1192 41.3656C80.4036 40.9281 80.7791 40.6 81.2458 40.3812C81.9603 40.0458 82.7041 39.7943 83.477 39.6266C84.2499 39.4589 85.0301 39.375 85.8176 39.375C86.6051 39.375 87.3853 39.4589 88.1583 39.6266C88.9312 39.7943 89.6749 40.0458 90.3895 40.3812C90.8562 40.6 91.2317 40.9281 91.5161 41.3656C91.8004 41.8031 91.9426 42.2771 91.9426 42.7875V44.625H79.6926ZM81.4426 42.875H90.1926V42.7875C90.1926 42.6125 90.1416 42.4521 90.0395 42.3062C89.9374 42.1604 89.8062 42.051 89.6458 41.9781C89.0333 41.701 88.4062 41.4896 87.7645 41.3437C87.1228 41.1979 86.4739 41.125 85.8176 41.125C85.1614 41.125 84.5124 41.1979 83.8708 41.3437C83.2291 41.4896 82.602 41.701 81.9895 41.9781C81.8291 42.051 81.6978 42.1604 81.5958 42.3062C81.4937 42.4521 81.4426 42.6125 81.4426 42.7875V42.875ZM85.8176 38.5C84.9718 38.5 84.2499 38.201 83.652 37.6031C83.0541 37.0052 82.7551 36.2833 82.7551 35.4375C82.7551 34.5917 83.0541 33.8698 83.652 33.2719C84.2499 32.674 84.9718 32.375 85.8176 32.375C86.6635 32.375 87.3853 32.674 87.9833 33.2719C88.5812 33.8698 88.8801 34.5917 88.8801 35.4375C88.8801 36.2833 88.5812 37.0052 87.9833 37.6031C87.3853 38.201 86.6635 38.5 85.8176 38.5ZM85.8176 36.75C86.1822 36.75 86.4921 36.6224 86.7473 36.3672C87.0025 36.112 87.1301 35.8021 87.1301 35.4375C87.1301 35.0729 87.0025 34.763 86.7473 34.5078C86.4921 34.2526 86.1822 34.125 85.8176 34.125C85.453 34.125 85.1431 34.2526 84.8879 34.5078C84.6327 34.763 84.5051 35.0729 84.5051 35.4375C84.5051 35.8021 84.6327 36.112 84.8879 36.3672C85.1431 36.6224 85.453 36.75 85.8176 36.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101.818,
    cy: 20.0004,
    r: 10.8441,
    fill: "url(#paint5_linear_2590_4897)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.7458 19.0579C94.9943 18.6002 101.608 18.3918 103.704 19.5298C105.8 20.6678 107.772 26.1299 107.004 27.5444C106.756 28.0021 103.914 22.5536 101.818 21.4156C99.7217 20.2776 90.5032 19.058 94.7458 19.0579Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.625 18.9928C99.777 18.7129 101.932 18.498 103.095 19.1295C104.258 19.7611 104.998 21.8765 104.846 22.1564C104.694 22.4364 103.689 20.6304 102.526 19.9988C101.363 19.3672 99.473 19.2728 99.625 18.9928Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 68.3174,
    y: 17.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.12,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bd_2590_4897)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2590_4897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.817,
    y: 17,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.379 37.1875L179.504 33.25L173.379 29.3125V37.1875ZM170.317 40.25C169.836 40.25 169.424 40.0786 169.081 39.7359C168.738 39.3932 168.567 38.9812 168.567 38.5V28C168.567 27.5187 168.738 27.1068 169.081 26.7641C169.424 26.4214 169.836 26.25 170.317 26.25H180.817C181.298 26.25 181.71 26.4214 182.053 26.7641C182.396 27.1068 182.567 27.5187 182.567 28V38.5C182.567 38.9812 182.396 39.3932 182.053 39.7359C181.71 40.0786 181.298 40.25 180.817 40.25H170.317ZM170.317 38.5H180.817V28H170.317V38.5ZM166.817 43.75C166.336 43.75 165.924 43.5786 165.581 43.2359C165.238 42.8932 165.067 42.4812 165.067 42V29.75H166.817V42H179.067V43.75H166.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 189.817,
    cy: 20.0004,
    r: 10.8441,
    fill: "url(#paint6_linear_2590_4897)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.745 19.0579C182.994 18.6002 189.607 18.3918 191.703 19.5298C193.799 20.6678 195.772 26.1299 195.004 27.5444C194.755 28.0021 191.913 22.5536 189.817 21.4156C187.721 20.2776 178.503 19.058 182.745 19.0579Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.625 18.9928C187.777 18.7129 189.931 18.498 191.094 19.1295C192.258 19.7611 192.997 21.8765 192.845 22.1564C192.693 22.4364 191.689 20.6304 190.525 19.9988C189.362 19.3672 187.473 19.2728 187.625 18.9928Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 156.317,
    y: 17.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.12,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_bd_2590_4897)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2590_4897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 73,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 98.875L44.875 95.55V90.3L41.375 88.375L51 83.125L60.625 88.375V95.375H58.875V89.3375L57.125 90.3V95.55L51 98.875ZM51 91.6125L56.9937 88.375L51 85.1375L45.0062 88.375L51 91.6125ZM51 96.8844L55.375 94.5219V91.2188L51 93.625L46.625 91.2188V94.5219L51 96.8844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.0004,
    cy: 76.0004,
    r: 10.8441,
    fill: "url(#paint7_linear_2590_4897)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9284 75.0579C60.1769 74.6002 66.7902 74.3918 68.8862 75.5298C70.9822 76.6678 72.9549 82.1299 72.1869 83.5444C71.9384 84.0021 69.0963 78.5536 67.0003 77.4156C64.9043 76.2776 55.6858 75.058 59.9284 75.0579Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8076 74.9928C64.9596 74.7129 67.1142 74.498 68.2774 75.1295C69.4406 75.7611 70.1804 77.8765 70.0284 78.1564C69.8764 78.4364 68.8717 76.6304 67.7085 75.9988C66.5452 75.3672 64.6557 75.2728 64.8076 74.9928Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 73.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.12,
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_bd_2590_4897)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2590_4897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.635,
    y: 73,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.385 89.1625V87.675C210.866 87.4708 211.358 87.3177 211.861 87.2156C212.364 87.1135 212.893 87.0625 213.447 87.0625C213.826 87.0625 214.198 87.0917 214.563 87.15C214.927 87.2083 215.285 87.2813 215.635 87.3688V88.7688C215.285 88.6375 214.931 88.5391 214.574 88.4734C214.216 88.4078 213.841 88.375 213.447 88.375C212.893 88.375 212.361 88.4443 211.85 88.5828C211.34 88.7214 210.851 88.9146 210.385 89.1625ZM210.385 93.975V92.4875C210.866 92.2833 211.358 92.1302 211.861 92.0281C212.364 91.926 212.893 91.875 213.447 91.875C213.826 91.875 214.198 91.9042 214.563 91.9625C214.927 92.0208 215.285 92.0938 215.635 92.1813V93.5813C215.285 93.45 214.931 93.3516 214.574 93.2859C214.216 93.2203 213.841 93.1875 213.447 93.1875C212.893 93.1875 212.361 93.2531 211.85 93.3844C211.34 93.5156 210.851 93.7125 210.385 93.975ZM210.385 91.5688V90.0813C210.866 89.8771 211.358 89.724 211.861 89.6219C212.364 89.5198 212.893 89.4688 213.447 89.4688C213.826 89.4688 214.198 89.4979 214.563 89.5563C214.927 89.6146 215.285 89.6875 215.635 89.775V91.175C215.285 91.0438 214.931 90.9453 214.574 90.8797C214.216 90.8141 213.841 90.7813 213.447 90.7813C212.893 90.7813 212.361 90.8505 211.85 90.9891C211.34 91.1276 210.851 91.3208 210.385 91.5688ZM203.822 94.5C204.507 94.5 205.175 94.5766 205.824 94.7297C206.473 94.8828 207.118 95.1125 207.76 95.4188V86.8C207.162 86.45 206.527 86.1875 205.856 86.0125C205.186 85.8375 204.507 85.75 203.822 85.75C203.297 85.75 202.776 85.801 202.258 85.9031C201.74 86.0052 201.241 86.1583 200.76 86.3625V95.025C201.27 94.85 201.777 94.7188 202.28 94.6313C202.783 94.5438 203.297 94.5 203.822 94.5ZM209.51 95.4188C210.151 95.1125 210.796 94.8828 211.445 94.7297C212.094 94.5766 212.762 94.5 213.447 94.5C213.972 94.5 214.486 94.5438 214.989 94.6313C215.492 94.7188 215.999 94.85 216.51 95.025V86.3625C216.028 86.1583 215.529 86.0052 215.011 85.9031C214.493 85.801 213.972 85.75 213.447 85.75C212.762 85.75 212.083 85.8375 211.413 86.0125C210.742 86.1875 210.107 86.45 209.51 86.8V95.4188ZM208.635 98C207.935 97.4458 207.176 97.0156 206.36 96.7094C205.543 96.4031 204.697 96.25 203.822 96.25C203.21 96.25 202.608 96.3302 202.017 96.4906C201.427 96.651 200.862 96.8771 200.322 97.1688C200.016 97.3292 199.72 97.3219 199.436 97.1469C199.152 96.9719 199.01 96.7167 199.01 96.3813V85.8375C199.01 85.6771 199.05 85.524 199.13 85.3781C199.21 85.2323 199.33 85.1229 199.491 85.05C200.162 84.7 200.862 84.4375 201.591 84.2625C202.32 84.0875 203.064 84 203.822 84C204.668 84 205.495 84.1094 206.305 84.3281C207.114 84.5469 207.891 84.875 208.635 85.3125C209.378 84.875 210.155 84.5469 210.964 84.3281C211.774 84.1094 212.601 84 213.447 84C214.205 84 214.949 84.0875 215.678 84.2625C216.407 84.4375 217.107 84.7 217.778 85.05C217.939 85.1229 218.059 85.2323 218.139 85.3781C218.219 85.524 218.26 85.6771 218.26 85.8375V96.3813C218.26 96.7167 218.117 96.9719 217.833 97.1469C217.549 97.3219 217.253 97.3292 216.947 97.1688C216.407 96.8771 215.842 96.651 215.252 96.4906C214.661 96.3302 214.06 96.25 213.447 96.25C212.572 96.25 211.726 96.4031 210.91 96.7094C210.093 97.0156 209.335 97.4458 208.635 98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 224.635,
    cy: 76.0004,
    r: 10.8441,
    fill: "url(#paint8_linear_2590_4897)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.563 75.0579C217.811 74.6002 224.425 74.3918 226.521 75.5298C228.617 76.6678 230.589 82.1299 229.821 83.5444C229.573 84.0021 226.731 78.5536 224.635 77.4156C222.539 76.2776 213.32 75.058 217.563 75.0579Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.442 74.9928C222.594 74.7129 224.749 74.498 225.912 75.1295C227.075 75.7611 227.815 77.8765 227.663 78.1564C227.511 78.4364 226.506 76.6304 225.343 75.9988C224.18 75.3672 222.29 75.2728 222.442 74.9928Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 191.135,
    y: 73.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.12,
    shapeRendering: "crispEdges"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_bd_2590_4897)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2590_4897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.8081,
    y: 129,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8081 154C71.3269 154 70.9149 153.829 70.5722 153.486C70.2295 153.143 70.0581 152.731 70.0581 152.25V141.75C70.0581 141.269 70.2295 140.857 70.5722 140.514C70.9149 140.171 71.3269 140 71.8081 140H82.3081C82.7894 140 83.2013 140.171 83.544 140.514C83.8868 140.857 84.0581 141.269 84.0581 141.75V145.688L87.5581 142.188V151.813L84.0581 148.313V152.25C84.0581 152.731 83.8868 153.143 83.544 153.486C83.2013 153.829 82.7894 154 82.3081 154H71.8081ZM71.8081 152.25H82.3081V141.75H71.8081V152.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94.8085,
    cy: 132,
    r: 10.8441,
    fill: "url(#paint9_linear_2590_4897)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7365 131.058C87.985 130.6 94.5984 130.392 96.6943 131.53C98.7903 132.668 100.763 138.13 99.995 139.544C99.7465 140.002 96.9044 134.554 94.8084 133.416C92.7125 132.278 83.4939 131.058 87.7365 131.058Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6158 130.993C92.7678 130.713 94.9223 130.498 96.0855 131.13C97.2487 131.761 97.9885 133.877 97.8365 134.156C97.6846 134.436 96.6798 132.63 95.5166 131.999C94.3533 131.367 92.4638 131.273 92.6158 130.993Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 61.3081,
    y: 129.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.12,
    shapeRendering: "crispEdges"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_bd_2590_4897)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2590_4897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.827,
    y: 129,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.951 156.58V154.83C178.128 154.626 176.564 153.872 175.259 152.566C173.954 151.261 173.199 149.697 172.995 147.874H171.245V146.124H172.995C173.199 144.301 173.954 142.737 175.259 141.432C176.564 140.127 178.128 139.372 179.951 139.168V137.418H181.701V139.168C183.524 139.372 185.088 140.127 186.394 141.432C187.699 142.737 188.453 144.301 188.658 146.124H190.408V147.874H188.658C188.453 149.697 187.699 151.261 186.394 152.566C185.088 153.872 183.524 154.626 181.701 154.83V156.58H179.951ZM180.826 153.124C182.518 153.124 183.962 152.526 185.158 151.33C186.353 150.135 186.951 148.691 186.951 146.999C186.951 145.308 186.353 143.864 185.158 142.668C183.962 141.472 182.518 140.874 180.826 140.874C179.135 140.874 177.691 141.472 176.495 142.668C175.299 143.864 174.701 145.308 174.701 146.999C174.701 148.691 175.299 150.135 176.495 151.33C177.691 152.526 179.135 153.124 180.826 153.124ZM180.826 150.499C179.864 150.499 179.04 150.157 178.354 149.471C177.669 148.786 177.326 147.962 177.326 146.999C177.326 146.037 177.669 145.213 178.354 144.527C179.04 143.842 179.864 143.499 180.826 143.499C181.789 143.499 182.613 143.842 183.298 144.527C183.984 145.213 184.326 146.037 184.326 146.999C184.326 147.962 183.984 148.786 183.298 149.471C182.613 150.157 181.789 150.499 180.826 150.499ZM180.826 148.749C181.308 148.749 181.72 148.578 182.062 148.235C182.405 147.892 182.576 147.48 182.576 146.999C182.576 146.518 182.405 146.106 182.062 145.763C181.72 145.421 181.308 145.249 180.826 145.249C180.345 145.249 179.933 145.421 179.59 145.763C179.248 146.106 179.076 146.518 179.076 146.999C179.076 147.48 179.248 147.892 179.59 148.235C179.933 148.578 180.345 148.749 180.826 148.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196.827,
    cy: 132,
    r: 10.8441,
    fill: "url(#paint10_linear_2590_4897)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.755 131.058C190.004 130.6 196.617 130.392 198.713 131.53C200.809 132.668 202.782 138.13 202.014 139.544C201.765 140.002 198.923 134.554 196.827 133.416C194.731 132.278 185.513 131.058 189.755 131.058Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_2590_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.634 130.993C194.786 130.713 196.941 130.498 198.104 131.13C199.267 131.761 200.007 133.877 199.855 134.156C199.703 134.436 198.698 132.63 197.535 131.999C196.372 131.367 194.482 131.273 194.634 130.993Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 163.327,
    y: 129.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.12,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2590_4897",
    x: 52,
    y: 13,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.920833 0 0 0 0 0.920833 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2590_4897",
    x: 102.333,
    y: 60,
    width: 59.3333,
    height: 71.0254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2590_4897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_2590_4897",
    x: 20.4339,
    y: -30.3835,
    width: 130.767,
    height: 130.767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.6917
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2590_4897"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8365
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376406 0 0 0 0 0.783837 0 0 0 0 0.9125 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2590_4897",
    result: "effect2_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2590_4897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2590_4897",
    x: 62.6847,
    y: -19.1327,
    width: 78.2662,
    height: 78.2654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2590_4897",
    x: 87.985,
    y: 13.0336,
    width: 24.8466,
    height: 20.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2590_4897",
    x: 97.7305,
    y: 16.8328,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bd_2590_4897",
    x: 108.433,
    y: -30.3835,
    width: 130.767,
    height: 130.767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.6917
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2590_4897"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8365
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376406 0 0 0 0 0.783837 0 0 0 0 0.9125 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2590_4897",
    result: "effect2_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2590_4897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2590_4897",
    x: 150.684,
    y: -19.1327,
    width: 78.2662,
    height: 78.2654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2590_4897",
    x: 175.985,
    y: 13.0336,
    width: 24.8466,
    height: 20.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2590_4897",
    x: 185.73,
    y: 16.8328,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_bd_2590_4897",
    x: -14.3835,
    y: 25.6165,
    width: 130.767,
    height: 130.767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.6917
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2590_4897"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8365
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376406 0 0 0 0 0.783837 0 0 0 0 0.9125 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2590_4897",
    result: "effect2_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2590_4897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2590_4897",
    x: 27.8673,
    y: 36.8673,
    width: 78.2662,
    height: 78.2654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2590_4897",
    x: 53.1676,
    y: 69.0336,
    width: 24.8466,
    height: 20.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2590_4897",
    x: 62.9131,
    y: 72.8328,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_bd_2590_4897",
    x: 143.251,
    y: 25.6165,
    width: 130.767,
    height: 130.767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.6917
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2590_4897"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8365
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376406 0 0 0 0 0.783837 0 0 0 0 0.9125 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2590_4897",
    result: "effect2_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2590_4897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_2590_4897",
    x: 185.502,
    y: 36.8673,
    width: 78.2662,
    height: 78.2654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_2590_4897",
    x: 210.802,
    y: 69.0336,
    width: 24.8466,
    height: 20.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_2590_4897",
    x: 220.548,
    y: 72.8328,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_bd_2590_4897",
    x: 13.4246,
    y: 81.6165,
    width: 130.767,
    height: 130.767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.6917
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2590_4897"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8365
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376406 0 0 0 0 0.783837 0 0 0 0 0.9125 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2590_4897",
    result: "effect2_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2590_4897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_2590_4897",
    x: 55.6754,
    y: 92.8673,
    width: 78.2662,
    height: 78.2654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_2590_4897",
    x: 80.9757,
    y: 125.034,
    width: 24.8466,
    height: 20.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_2590_4897",
    x: 90.7212,
    y: 128.833,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_bd_2590_4897",
    x: 115.443,
    y: 81.6165,
    width: 130.767,
    height: 130.767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.6917
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2590_4897"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8365
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376406 0 0 0 0 0.783837 0 0 0 0 0.9125 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2590_4897",
    result: "effect2_dropShadow_2590_4897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2590_4897",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_2590_4897",
    x: 157.694,
    y: 92.8673,
    width: 78.2662,
    height: 78.2654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_2590_4897",
    x: 182.994,
    y: 125.034,
    width: 24.8466,
    height: 20.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_2590_4897",
    x: 192.74,
    y: 128.833,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_2590_4897"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2590_4897",
    x1: 68.5385,
    y1: 160.895,
    x2: 218.952,
    y2: 137.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2590_4897",
    x1: 30.4615,
    y1: 201.632,
    x2: 271.123,
    y2: 164.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2590_4897",
    x1: 197.709,
    y1: 168.941,
    x2: 227.104,
    y2: 115.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2590_4897",
    x1: 93.0769,
    y1: 134.642,
    x2: 185.33,
    y2: 120.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2590_4897",
    x1: 126.815,
    y1: 109.856,
    x2: 159.229,
    y2: 84.5072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2590_4897",
    x1: 102.289,
    y1: 20.0004,
    x2: 101.818,
    y2: 39.3312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2590_4897",
    x1: 190.289,
    y1: 20.0004,
    x2: 189.817,
    y2: 39.3312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2590_4897",
    x1: 67.4718,
    y1: 76.0004,
    x2: 67.0004,
    y2: 95.3312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2590_4897",
    x1: 225.106,
    y1: 76.0004,
    x2: 224.635,
    y2: 95.3312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2590_4897",
    x1: 95.2799,
    y1: 132,
    x2: 94.8085,
    y2: 151.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2590_4897",
    x1: 197.298,
    y1: 132,
    x2: 196.827,
    y2: 151.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2590_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2590_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.8174,
    y: 17,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2590_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.817,
    y: 17,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2590_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 73,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2590_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.635,
    y: 73,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2590_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.8081,
    y: 129,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2590_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.827,
    y: 129,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveWorkshops);
export default __webpack_public_path__ + "static/media/exclusive-workshops.0bd98c87ddf31edc76c2f99aaeb24163.svg";
export { ForwardRef as ReactComponent };